import ITenant from "../types/ITenant";

let _currentEnv:string = '';

const firebaseConfigs:any = {
    prod: {
        apiKey: "AIzaSyAgqWY5nS3vNmPQylfDMu-b9aZ2nxjrE6g",
        authDomain: "meetingapp-273918.firebaseapp.com",
        databaseURL: "https://meetingapp-273918.firebaseio.com",
        projectId: "meetingapp-273918",
        storageBucket: "meetingapp-273918.appspot.com",
        messagingSenderId: "507963625992",
        appId: "1:507963625992:web:da26ccca6b2c7279cbb7bd",
        measurementId: "G-TVZTV5JWNF"
      },
    qa: {
        apiKey: "AIzaSyA4KcORHD7Yz2cjo2jFrEvIPFv7CE_8Cyc",
        authDomain: "og-ordertest.firebaseapp.com",
        databaseURL: "https://og-ordertest.firebaseio.com",
        projectId: "og-ordertest",
        storageBucket: "gs://doc-library-input",
        messagingSenderId: "824586943685",
        appId: "1:824586943685:web:24e0032c66b33c21cc44ac"
      }
}

export function getCurrentEnv():string {
    return _currentEnv;
}

export function getCurrentTenant() :ITenant {
    let tenant = {} as ITenant;
    const win:any = window;
    let hostname:any = win.location.hostname;
    /*if(hostname === 'localhost' || hostname.indexOf('og-ordertest') != -1)
        tenant = {
            tenantId: 'salesplay'
        }
    else {
        if(hostname.length > 0 && hostname.indexOf(".salesplay.app") > 0){
            const subdomain: string = hostname.split('.')[0]
            tenant = {
                tenantId: subdomain
            }
        }
    }*/
    tenant = {
        tenantId: 'salesplay'
    }
    return tenant;
}

export default function getFirebaseEnv():any {
    const win:any = window;
    let hostname:any = win.location.hostname;
    if(hostname === 'localhost' || hostname.indexOf('og-ordertest') != -1)
        _currentEnv = 'qa';
    else 
        _currentEnv = 'prod';
    return firebaseConfigs[_currentEnv];
}